import { observer } from 'mobx-react';

import Profile from '../Profile/Profile';
import useStores from '../../../../utils/useStores';

const Landing = observer(() => {
  const rootStore = useStores();
  
  console.log(rootStore);
  const shownPanes = <Profile />;
  
  return (
    <div>
      {shownPanes}
    </div>
  );
});

export default Landing;